guitarGame_item=function(conf,resources){
    PIXI.Container.call(this);
    conf=$.extend({
        pos_start:[0,0],
        pos_end:[100,100],
        pos_end_real:[100,100],

        type:"norm",
        scale_arr:[100,100],
        rotation_arr:[0,0],
        elementConf:{
            img:"heart",
            anim_type:"img",
        },
        a:0,
        v:0,
        onEndAnim:function(){},
        onFail:function(){},
        line_id:-1,
        howlong:0,
        path_name:"",
        path_pos:[0,0],
        path_anchor:[0.5,0.5],

        step_howlong:1000/60,
    },conf);


    this.conf=conf;
    this.was_catch=0;
    this.pathFrame;
    this.pathSize=[];
    this.pathConf={
        len:0,
        color_id:0,
        margin_top:0
    };
//    this.width=this.conf.path_conf.width;
//    this.height=this.conf.path_conf.height;




    this.step=0;
    this.step_all=0;
    this.step_max=0;
    this.step_delete=0;
    this.step_part=0;

    this.step_opacity=0;
    this.step_opacity_max=10;


    this.v_max=this.conf.v;
    this.start_point=copyArray(conf.pos_start);
    this.end_point=copyArray(conf.pos_end);
    this.scale_arr=copyArray(conf.scale_arr);
    this.scale_int=conf.scale_arr[0];


    this.was_ended=0;

    this.dir=makeVector(this.start_point,this.end_point);
    this.dir_len=lengthVector(this.dir);
    this.dir_part=[0,this.dir_len];
    this.imgName=conf.img;


    this.myObj = new myPixiElement[conf.elementConf.anim_type](conf.elementConf);

    if(this.scale_int!=100){
        this.myObj.scale.set(this.scale_int/100,this.scale_int/100);
    }


    if(conf.a!=0){




        this.dir_part=[this.dir_len/3,this.dir_len*2/3];
        this.step_part=(-conf.v+Math.sqrt(conf.v*conf.v+2*this.dir_part[0]*conf.a))/conf.a;

        this.v_max=conf.a*this.step_part+conf.v;
        this.step_max=this.step_part+this.dir_part[1]/this.v_max;

    }
    else{
        this.step_max=this.dir_len/conf.v;
    }


    this.myObj.x=this.start_point[0];
    this.myObj.y=this.start_point[1];




    if(conf.howlong>0){
//        path_name:""
//        path_pos:[0,0],
//        path_anchor:[0.5,0.5]

        var pathContainer=new PIXI.Container();

        this.pathTexture =new PIXI.Texture(resources[this.conf.path_name].texture);
        this.pathSize=[this.pathTexture.baseTexture.width/2,this.pathTexture.baseTexture.height];
        pathContainer.width=this.pathSize[0];
        pathContainer.height=this.pathSize[1];
        pathContainer.pivot.set(this.conf.path_anchor[0]*this.pathSize[0],this.conf.path_anchor[1]*this.pathSize[1]);
        pathContainer.x=this.conf.path_pos[0];
        pathContainer.y=this.conf.path_pos[1];
        this.pathConf.margin_top=this.conf.path_pos[1]-this.pathSize[1];
//        $.qLog(" a"+this.pathConf.margin_top+"a ");

        var frameRectangle = new PIXI.Rectangle(this.pathSize[0], 0, this.pathSize[0],this.pathSize[1]);
        this.pathTexture.frame= frameRectangle;
        this.pathObj=new PIXI.Sprite(this.pathTexture);
//        path.x=this.conf.path_pos[0];
//        path.y=this.conf.path_pos[1];
//        path.anchor.set(this.conf.path_anchor[0],this.conf.path_anchor[1]);
        pathContainer.addChild(this.pathObj);
        this.addChild(pathContainer);
        //this.conf.step_howlong

        var pathSteps=conf.howlong/this.conf.step_howlong;


        this.pathConf.len=pathSteps*this.v_max;
        var tga=this.pathSize[0]/this.pathSize[1];
        this.pathConf.cos=1/Math.sqrt(tga*tga+1);

        this.updateFramePath(this.myObj.x,this.myObj.y,this.scale_int);

        this.step_delete=(this.step_max+pathSteps+this.step_opacity_max)*1.2;

    }
    else{
        this.step_delete=(this.step_max+this.step_opacity_max)*1.2;
    }



    this.addChild(this.myObj);

//    var texture =new PIXI.Texture(resources[conf.path_conf.texture_name].texture);
//    var frameRectangle = new PIXI.Rectangle(0, 0, conf.path_conf.width, conf.path_conf.height);
//    texture.frame= frameRectangle;
//    this.background=new PIXI.Sprite(texture);



};
guitarGame_item.prototype = Object.create(PIXI.Container.prototype);
guitarGame_item.prototype= $.extend(guitarGame_item.prototype,{
    update:function(delta){
//        this.myObj.myUpdate(delta);
        this.step_all+=delta;
        if(this.step_max==0){
            return 1;
        }
        var s;
        if(this.step_all>this.step_part){
            s=this.dir_part[0];
            s+=(this.step_all-this.step_part)*this.v_max;

        }
        else{
            s=this.conf.v*this.step_all+0.5*this.conf.a*this.step_all*this.step_all;
        }


        this.step=s/this.dir_len*this.step_max;
//        $.qLog(this.step+" "+this.step_all+"<br>");



        var div=s/this.dir_len;

        var x,y;
        x=this.dir[0]*div+this.start_point[0];
        y=this.dir[1]*div+this.start_point[1];
        this.updateFramePath(x,y,this.scale_int);
        if(y>this.conf.pos_end_real[1]){
            x=this.conf.pos_end_real[0];
            y=this.conf.pos_end_real[1];
        }
        else{
            if(this.scale_arr[0]!=this.scale_arr[1]){
                this.scale_int=Math.min(this.scale_arr[0]+(this.scale_arr[1]-this.scale_arr[0])*div,100);
                this.myObj.scale.set(this.scale_int/100,this.scale_int/100);
            }
        }

        this.myObj.x=x;
        this.myObj.y=y;


//





        if(this.step>=this.step_max && this.was_ended==0){
            this.was_ended=1;
            if(this.was_catch==0){
                //fail
                this.conf.onFail(this.conf.line_id,this.takePos(),this.conf.elementConf.img,this);
                this.endPath();
            }
            if(typeof this.conf.onEndAnim=="function"){
                this.conf.onEndAnim();
            }
        }
        if(this.was_ended && this.was_catch==0){

            this.step_opacity++;
            if(this.step_opacity<=this.step_opacity_max){
                this.alpha=(this.step_opacity_max-this.step_opacity)/this.step_opacity_max;

            }
        }
        if(this.step_all>this.step_delete){
            return 0;
        }


        return 1;
    },
    endPath:function(){
        if(this.conf.howlong==0){
            return false;
        }
        this.pathObj.alpha=0.5;
        return true;
    },
    updateFramePath:function(x,y,scale){
        if(this.conf.howlong==0){
            return false;
        }
        scale=100;;
        var height=scale*this.pathConf.len*this.pathConf.cos/100;
        var bug_margin=0;

        y-=this.pathConf.margin_top;

        var top=y-height+bug_margin;
        if(top<0){
            height=Math.max(0,height-top);
            top=0;
        }
        top=Math.min(top,this.pathSize[1]);
        if(top+height>this.pathSize[1]){
            height=this.pathSize[1]-top;
        }
        if(height+top>y+bug_margin){
            height=y+bug_margin-top;
        }


        var color_int=this.pathSize[0]*this.pathConf.color_id;
//        height=130;
//        top=200;
        this.pathObj.y=top;
//        $.qLog(Math.round(y)+"_"+Math.round(top)+"_"+Math.round(height)+"<br>");


        var frameRectangle = new PIXI.Rectangle(color_int, top, this.pathSize[0], height);
        this.pathTexture.frame= frameRectangle;

    },
    hide:function(){
        this.alpha=0;
    },
    hideHero:function(){
        this.myObj.alpha=0;
    },
    takePos:function(){
        return [this.myObj.x,this.myObj.y];
    },
    remove:function(){
        this.myObj.myRemove();
        this.destroy();
    },
    canCatch:function(){
        if(this.was_catch!=0){
            return 0;
        }
        if(this.was_ended){
            return 0;
        }
        return 1;
    },
    wasCatch:function(){
        if(this.was_catch!=0){
            return 0;
        }
        this.was_catch=this.step_all;
        this.pathConf.color_id=1;
        var ret={img:this.conf.elementConf.img,x:this.myObj.x,y:this.myObj.y};

        return ret;
    },
    endCatch:function(){
        var ret={mili:0,howlong:this.conf.howlong,percent:0};
        if(this.was_catch<1){
            return ret;
        }
        if(this.conf.howlong==0){
            return ret;
        }
        this.endPath();
        this.pathConf.color_id=0;
        var steps=this.step_all-this.was_catch;
        this.was_catch=-1;
        var mili=Math.round(this.conf.step_howlong*steps);//mili seconds
        mili=Math.min(mili,this.conf.howlong);
        ret.percent=100*mili/this.conf.howlong;
        ret.mili=mili;
        return ret;

    }
});







guitarGame_bomb=function(conf,resources){
    PIXI.Container.call(this);
    conf=$.extend({
        pos_start:[0,0],
        pos_end:[100,100],
        pos_end_real:[100,100],
        img:"heart",
        type:"norm",
        scale_arr:[100,100],
        rotation_arr:[0,0],
        anim_type:"img",
        a:0,
        v:0,
        onEndAnim:function(){},
        onFail:function(){},
        line_id:-1,
        bomb_state:"active",

        step_howlong:1000/60,
    },conf);

    this.conf=conf;
    this.was_catch=0;

    this.step=0;
    this.step_all=0;
    this.step_max=0;
    this.step_delete=0;
    this.step_part=0;

    this.step_opacity=0;
    this.step_opacity_max=10;

    this.v_max=this.conf.v;
    this.start_point=copyArray(conf.pos_start);
    this.pos_last=copyArray(conf.pos_start);
    this.end_point=copyArray(conf.pos_end);
    this.scale_arr=copyArray(conf.scale_arr);
    this.scale_int=conf.scale_arr[0];

    this.bomb_state={state:this.conf.bomb_state,y:this.pos_last[1]};

    this.was_ended=0;

    this.dir=makeVector(this.start_point,this.end_point);
    this.dir_len=lengthVector(this.dir);
    this.dir_part=[0,this.dir_len];
    this.imgName=conf.img;


    this.myObj = new myPixiElement[conf.anim_type](conf);

    if(this.scale_int!=100){
        this.myObj.scale.set(this.scale_int/100,this.scale_int/100);
    }


    if(conf.a!=0){
        this.dir_part=[this.dir_len/3,this.dir_len*2/3];
        this.step_part=(-conf.v+Math.sqrt(conf.v*conf.v+2*this.dir_part[0]*conf.a))/conf.a;

        this.v_max=conf.a*this.step_part+conf.v;
        this.step_max=this.step_part+this.dir_part[1]/this.v_max;
    }
    else{
        this.step_max=this.dir_len/conf.v;
    }
    this.step_delete=this.step_max+this.step_opacity_max;

    this.myObj.x=this.start_point[0];
    this.myObj.y=this.start_point[1];

    this.addChild(this.myObj);
};
guitarGame_bomb.prototype = Object.create(PIXI.Container.prototype);
guitarGame_bomb.prototype= $.extend(guitarGame_bomb.prototype,{
    setState:function(state){
        if(this.bomb_state.state==state){
            return false;
        }
        this.bomb_state={state:state,y:this.myObj.y};
        return true;
    },
    update:function(delta){
//        this.myObj.myUpdate(delta);
        this.step_all+=delta;
        if(this.step_max==0){
            return 1;
        }
        var s;
        if(this.step_all>this.step_part){
            s=this.dir_part[0];
            s+=(this.step_all-this.step_part)*this.v_max;
        }
        else{
            s=this.conf.v*this.step_all+0.5*this.conf.a*this.step_all*this.step_all;
        }


        this.step=s/this.dir_len*this.step_max;


        var div=s/this.dir_len;

        var x,y,x_org,y_org;
        x=this.dir[0]*div+this.start_point[0];
        y=this.dir[1]*div+this.start_point[1];
        x_org=x;
        y_org=y;
        if(y>=this.conf.pos_end_real[1]){
            x=this.conf.pos_end_real[0];
            y=this.conf.pos_end_real[1];
            this.step=this.step_max;
        }
        else{
            if(this.scale_arr[0]!=this.scale_arr[1]){
                this.scale_int=Math.min(this.scale_arr[0]+(this.scale_arr[1]-this.scale_arr[0])*div,100);
                this.myObj.scale.set(this.scale_int/100,this.scale_int/100);
            }
        }

        this.myObj.x=x;
        this.myObj.y=y;


//        





        if(this.step>=this.step_max && this.was_ended==0){
            this.was_ended=1;
            if(this.bomb_state.state=="active" && Math.abs(y_org-this.pos_last[1])<40){

                this.conf.onFail.call(this,this.conf.line_id);
            }
            else{
                if(typeof this.conf.onEndAnim=="function"){
                    this.conf.onEndAnim();
                }
            }


        }
        if(this.was_ended && this.was_catch==0){

            this.step_opacity++;
            if(this.step_opacity<=this.step_opacity_max){
                this.myObj.alpha=(this.step_opacity_max-this.step_opacity)/this.step_opacity_max;

            }
        }
        if(this.step_all>this.step_delete){
            return 0;
        }
        this.pos_last=[x_org,y_org];

        return 1;
    },
    hide:function(){
        this.alpha=0;
    },
    takePos:function(){
        return [this.myObj.x,this.myObj.y];
    },
    remove:function(){
        this.myObj.myRemove();
        this.destroy();
    },
});

